module.exports = __webpack_public_path__ + "static/media/stone-blue.991272b3.png";